// The Payment format filter's "not specified" option rides as a sentinel inside paymentFormats, like
// the currency filter's EMPTY. The backend types paymentFormats as an enum and would reject it, so
// split it out into the paymentFormatIsEmpty flag before every request.
export const PAYMENT_FORMAT_EMPTY = 'EMPTY';

export const splitPaymentFormatFilter = (paymentFormats) => {
  const selected = paymentFormats || [];
  return {
    paymentFormats: selected.filter((id) => id !== PAYMENT_FORMAT_EMPTY),
    paymentFormatIsEmpty: selected.includes(PAYMENT_FORMAT_EMPTY),
  };
};
